var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d2-container',[_c('d2-page-cover',{attrs:{"title":"内置组件","sub-title":"SuntrayAdmin 为你提供了一些上手即用的组件"}},[_c('img',{attrs:{"src":require("./image/icon.png")}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }